module.exports = __webpack_public_path__ + "img/9788992573962.059ddbc0.jpg";